module.exports = __webpack_public_path__ + "img/n_shop_bg1.c7298071.png";